// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { ENDPOINTS } from './endpoints';

export const environment = {
  production: false,
  // apiUrl: 'http://localhost:8000',
  // apiUrlBase: 'http://localhost:8000',
  apiUrl: 'https://simaknowledge.com',
  apiUrlBase: 'https://simaknowledge.com',
  endpoints: ENDPOINTS,
  pushNotificationUrl: 'https://onesignal.com/api/v1/notifications',
  apiKey: 'ZjgxNmMwZTEtMzI5ZC00NDI5LTgzNTItNzZhZjMxY2Q1ZTc1',
  appId: '65db15b2-66ee-4a3a-8f97-ad2af927d357',
  aiURL: 'https://api.openai.com/v1/chat/completions',
  aiApiKey: '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',
  firebase:{
    apiKey: "AIzaSyDnGH5MgZ6DBkeCa_kFJac-P4wJ6EdNeBo",
    authDomain: "simaonesignal.firebaseapp.com",  
    databaseURL: "https://simaonesignal-default-rtdb.firebaseio.com",  
    projectId: "simaonesignal",  
    storageBucket: "simaonesignal.appspot.com",  
    messagingSenderId: "109298367473",  
    appId: "1:109298367473:web:6887ce7b1bff8e60fd6250",  
    measurementId: "G-Q3327V73T7"  
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
